import { useState, useEffect } from "react";
import "./Contact.css";
import { ContactResponse } from "../config/responseSettings";

type ContactProps = {
    contact: ContactResponse;
}

export const Contact = ({contact} : ContactProps) => {
    console.log("[Contact] contact: ", contact);

    const isEmptyContact = !contact.firstName && !contact.lastName && !contact.company && !contact.phone && !contact.email;

    return (
        <>
            {!isEmptyContact &&
                <div className="contact">
                    <div className="contact-name">
                        {contact.firstName} {contact.lastName}
                    </div>
                    <div className="contact-company">
                        {contact.company}
                    </div>
                    <div className="contact-phone">
                        {contact.phone}
                    </div>
                    <div className="contact-email">
                        {contact.email}
                    </div>
                </div>
            }
        </>
    )
}